function recommenAddToCart(){
  document.querySelectorAll('.variant-options').forEach(function(selectElement) {
    // console.log("selectElement",selectElement);
    selectElement.addEventListener('change', function(event) {
      const selectedValue = event.target.value;
      // console.log("selectedValue",selectedValue);
      const closestRecommendationProduct = event.target.closest('.recommendation-product');
      const atcButton = closestRecommendationProduct.querySelector('.product-atc-btn');
      atcButton.setAttribute("data-variant-id",selectedValue);
    });
  });

  const customAddToCarts = document.querySelectorAll(".product-atc-btn");
  customAddToCarts.forEach(function(customAddToCart){
    customAddToCart.addEventListener('click',function(){
      const variant_id = customAddToCart.getAttribute("data-variant-id");
      
      let sections = ['cart-drawer', 'cart-icon-bubble'];
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            id: variant_id,
  			quantity: 1,
  			sections: sections
    	  }),
        })
        .then((res) => res.json())
        .then((response) => { 
            // const cartbtn = document.querySelector('#cart-icon-bubble');
            const cartDrawer = document.querySelector('cart-drawer');
            cartDrawer.classList.remove('is-empty');          
            cartDrawer.renderContents(response);
            // cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
        })
        .catch((error) => {
          console.error('Error:', error);
        });  
    });
  });
}

function upsellRecommended() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer.classList.contains('is-empty')) {
    const cartDrawer = document.querySelector('.cart-drawer');
    const productRecommendationsSection = cartDrawer.querySelector('.product-recommendations');
  
    if (!productRecommendationsSection) {
      console.error("Product recommendations section not found.");
      return;
    }
  
    const url = productRecommendationsSection.dataset.url;
  
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (recommendations && recommendations.innerHTML.trim().length) {
          const productRecommendationsWrapper = cartDrawer.querySelector('.product-recommendations-wrapper');
          productRecommendationsWrapper.innerHTML = recommendations.innerHTML;
        } else {
          console.error("No recommendations found in the fetched content.");
        }
      })
      .catch(e => {
        console.error("Error fetching recommendations:", e);
      }).finally(() => {
        // Code here will run whether the fetch was successful or there was an error.
        recommenAddToCart();
      });
  }
}

    async function applyDiscountCodeToCart(cartId, discountCode, shopifyToken) {

      const myHeaders = new Headers();
      myHeaders.append("X-Shopify-Storefront-Access-Token", shopifyToken);
      myHeaders.append("Content-Type", "application/json");
  
      const graphql = JSON.stringify({
          query: `
              mutation UpdateCartDiscountCodes($cartId: ID!, $discountCodes: [String!]!) {
                  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                      cart {
                          id
                          discountCodes {
                              code
                              applicable
                          }
                          checkoutUrl
                      }
                      userErrors {
                          code
                          field
                          message
                      }
                  }
              }
          `,
          variables: {
              "cartId": `gid://shopify/Cart/${cartId}`,
              "discountCodes": [discountCode]
          }
      });
  
      const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql,
          redirect: "follow"
      };
  
      try {
          const response = await fetch("/api/2024-10/graphql.json", requestOptions);
        // console.log("Response",response);
          const result = await response.json();
  
          const applicable = result.data.cartDiscountCodesUpdate.cart.discountCodes[0]?.applicable;
          return { success: true, applicable };
      } catch (error) {
          console.error('Error:', error);
          return { success: false, error };
      }
  }

// Function to fetch the cart token from Shopify's /cart.js endpoint
async function getCartToken() {
    try {
        const response = await fetch('/cart.js');
        const cartData = await response.json();
        return cartData.token; // This will return the cart token
    } catch (error) {
        console.error("Error fetching cart:", error);
        return null;
    }
}


// Function to apply discount code
async function appliedDiscountCode(discountCode,discountInput) {
  
  const myCartTokenId = await getCartToken(); // Fetch cart token
  // console.log("myCartTokenId",myCartTokenId);
  // console.log("APLLICABLE DISCOUNT",discountCode);
  if (myCartTokenId) {
      const cartId = decodeURIComponent(myCartTokenId);
      const myShopifyToken = '6a6faff9cf1e9ea0e20b4c0917ee79ff';

      const result = await applyDiscountCodeToCart(cartId, discountCode, myShopifyToken);
        var sections = ['cart-drawer', 'cart-icon-bubble']; // Sections to update

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({   
            sections: sections 
          })
        })
        .then(res => res.json())
        .then((response) => {
          console.log("Discount Applied:", response);
          const cartbtn = document.querySelector('#cart-icon-bubble');
          const cartDrawer = document.querySelector('cart-drawer');
      
          cartDrawer.classList.remove('is-empty');          
          cartDrawer.renderContents(response); 
          var discount_addButton = document.querySelector(".discount_wrapper .discount_add_btn");
          var discount_removeBtn = document.querySelector(".discount_wrapper .discount_remove_btn");
          var discountInput = document.querySelector(".discount_wrapper .discount_input");
          if(discount_addButton){
            discount_addButton.addEventListener('click',function(){
              discountInput.classList.remove('hidden');
              discount_removeBtn.classList.remove('hidden');
              discount_addButton.classList.add('hidden');
            });
          }
          
          if(discount_removeBtn){
            discount_removeBtn.addEventListener('click',function(){
               discountInput.classList.add('hidden');
              discount_addButton.classList.remove('hidden');
              discount_removeBtn.classList.add('hidden');
            });
          }
        })
        .catch(error => {
          console.error('Error applying discount:', error);
        });
      
      if (result.success && result.applicable) {

        const discountLabel = document.querySelector(".applied_discount .valid_discount");
        // console.log("discountLabel",discountLabel);
          discountLabel.textContent = discountCode;
          discountLabel.closest(".applied_discount").style.display = 'flex';
          console.log(`Discount code "${discountCode}" applied successfully!`);
          discountInput.value = '';
        discountInput.dispatchEvent(new Event('input')); 
          localStorage.setItem("discount_code", discountCode);
          return result; // Exit after successfully applying one code
        document.querySelector(".errorText").textContent = '';
      } else {
          console.log(`Discount code "${discountCode}" is not applicable.`);
        // document.querySelector(".errorText").textContent = 'Please enter a valid coupon code';
      }
  } else {
      console.log("No cart token or discount code found.") ;
      const discountLabel = document.querySelector(".applied_discount .valid_discount");
      // console.log("discountLabel",discountLabel);
      // if(discountLabel) discountLabel.innerHTML = discountCode;
      discountLabel.textContent = '';
  }
}


function cartValidateDiscount(){
  var cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer.classList.contains('is-empty')) {

  // document.querySelector(".applied_discount").style.display = 'none';
  // Check if discount code is already applied 
  var appliedDiscount = localStorage.getItem("discount_code");
  // if(appliedDiscount != null){
  //     const discountLabel = document.querySelector(".applied_discount .valid_discount");
  //     discountLabel.textContent = appliedDiscount;
  //      document.querySelector(".applied_discount").style.display = 'block';
  // }
  
  var discountWrapper = document.querySelector(".discount_wrapper");
  var discountApplyButton = discountWrapper.querySelector("button");
    
    if (discountApplyButton) {
      discountApplyButton.addEventListener('click', function(event) {
        event.preventDefault(); 
        var discountInput = discountWrapper.querySelector("input");
        var value = discountInput.value;
        if(value){
          document.querySelector(".errorText").textContent = '';
          console.log("Value",value);
          appliedDiscountCode(value,discountInput); 
        }else{
          console.log("Please enter coupon code");
          document.querySelector(".errorText").textContent = 'Please enter a coupon code';
        }
      });
    }

    var removeDiscountBtn = document.querySelector(".applied_discount .remove-btn");
    if(removeDiscountBtn){
      removeDiscountBtn.addEventListener('click',function(){
        var value = '';
        console.log("discount_code",value);
        appliedDiscountCode(value);
        const discountLabel = document.querySelector(".applied_discount .valid_discount");
        discountLabel.textContent = '';
        localStorage.removeItem("discount_code");
        this.closest(".applied_discount").style.display = 'none';
      });
    }

  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    upsellRecommended();
    cartValidateDiscount();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
    upsellRecommended();
    cartValidateDiscount();
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
